import React from "react";
import { Route } from "react-router-dom";

const Dashboard = React.lazy(() => import("../containers/Dashboard"));
const TaskManager = React.lazy(() => import("../containers/TaskManager"));

export default () => {
  return [
    <Route
      key="dashboard"
      path={"/"} 
      element={<Dashboard />}
    />,
    <Route
      key="taskManager"
      path={"/manage-tasks"} 
      element={<TaskManager />} 
    />,
  ];
};
 

function Yoo() {
  return (
    <h1>Yoo</h1>
  )
}
 
